import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { HeroTravel } from './HeroTravel';
import { HeroWhimsical } from './HeroWhimsical';
import { HeroClassical } from './HeroClassical';

export const Hero = () => {
  const { currentTheme } = useTheme();

  // iWasHere.me rebrand: Use new travel-themed hero as default
  // Keep vintage theme for special occasions
  if (currentTheme === 'vintage') {
    return <HeroClassical />;
  }

  // Default to new travel hero for all other themes (including whimsical)
  return <HeroTravel />;
};
